import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV2, CheckBoxFieldv2 } from '@labrav/react-components'
import { FormikHandlers, FormikProps, useFormikContext } from 'formik'
import {
  ChannelPartnerPrivateOfferInCreation,
  CppoPriceAdjustmentType,
} from '../../../../modules/channelPartnerPrivateOffer/reducer'
import { useStyles } from '../AddEditChannelOfferComponents.styles'
import { ScheduleType } from '../../../../modules/privateOffer/reducer'
import type { ReceivedResellerAuthorization } from '../../../../modules/receivedResellerAuthorization/reducer'

export const FlexiblePaymentTerm = ({
  resaleAuthorization,
}: {
  resaleAuthorization?: ReceivedResellerAuthorization
}) => {
  const { classes } = useStyles()
  const formikProps =
    useFormikContext() as FormikProps<ChannelPartnerPrivateOfferInCreation>
  const {
    values,
    handleChange,
    setFieldTouched,
    setFieldValue,
    setFieldError,
  } = formikProps

  const handleCheckboxChange =
    (handleChange: FormikHandlers['handleChange']) =>
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      handleChange({
        target: {
          name: 'flexiblePaymentTerms',
          value: e.target.checked,
        },
      })

      setFieldValue('installments', [
        { paymentDate: '', amount: null, currency: 'USD' },
      ])
      setFieldValue('flexiblePaymentType', ScheduleType.CUSTOM)

      if (values?.priceAdjustmentType === CppoPriceAdjustmentType.FIXED) {
        setFieldValue('priceAdjustmentType', CppoPriceAdjustmentType.PERCENTAGE)
        setFieldValue('adjustmentPercentageInputValue', null)
        setFieldValue('adjustmentPercentage', null)
        setFieldTouched('priceAdjustmentType', false)
        setFieldTouched('adjustmentPercentageInputValue', false)
        setFieldError('adjustmentPercentageInputValue', '')
      }

      const dimensions = values?.dimensions
        ?.map(dimensionItem => {
          const resaleAuthorizationDimension =
            resaleAuthorization?.dimensions?.find(
              item =>
                item?.name === dimensionItem?.name &&
                item?.isAdditionalUsageAllowed ===
                  dimensionItem?.isAdditionalUsageAllowed
            )
          return {
            ...resaleAuthorizationDimension,
            ...(dimensionItem?.id ? { id: dimensionItem?.id } : {}),
          }
        })
        .sort((firstDimension, secondDimension) => {
          if (
            firstDimension?.isAdditionalUsageAllowed ===
            secondDimension?.isAdditionalUsageAllowed
          )
            return 0
          return firstDimension.isAdditionalUsageAllowed ? 1 : -1
        })
      await setFieldValue('dimensions', dimensions)
      await setFieldTouched('dimensions', false)
      await setFieldError('dimensions', '')
    }
  return (
    <BoxV2
      heading={'Payment configuration'}
      headingIcon={
        <FontAwesomeIcon
          icon={faListCheck}
          style={{ width: '18px', height: '14px' }}
        />
      }
    >
      <div
        className={classes.flexiblePaymentTermWrapper}
        data-testid={'flexible-section'}
      >
        <CheckBoxFieldv2
          keyName="flexiblePaymentTerms"
          title="Allow buyer to pay in installments under flexible payment schedule"
          value={!!values.flexiblePaymentTerms}
          onChangeBox={handleCheckboxChange(handleChange)}
        />
      </div>
    </BoxV2>
  )
}
